import { Outlet } from 'react-router-dom';
import Header from './Header';
import ErrorBoundary from '../Common/ErrorBoundary';

const MemberLayout = () => {
  return (
    <div className="member-layout min-h-screen flex flex-col bg-gray-50">
      {/* Header only – no Sidebar */}
      {/* <Header /> */}
      
      {/* Main content – full width */}
      <main className="flex-1">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
    </div>
  );
};

export default MemberLayout;